<template>
  <div class="flex flex-col mb-3">
    <div class="mb-1 text-sm">
      <span>{{ label }}</span>
      <vx-tooltip
        v-if="tooltip"
        :text="tooltip"
        position="bottom"
        class="ml-2 inline-block opacity-75"
      >
        <feather-icon icon="InfoIcon" svg-classes="h-4 w-4" />
      </vx-tooltip>
    </div>
    <div class="flex">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: null,
    },
    tooltip: {
      type: String,
      default: null,
    },
  },
};
</script>